"use client";

import { Icon } from "@stone-payments/jade";
import { share } from "@/app/(store)/_utils/share";
import { storeAnalitica } from "@/app/(store)/_utils/events";
import { useStore } from "@/contexts/store";
import { MessageBuilder } from "@/utils/message-builder";
import { useExperiment } from "@/contexts/analitica";
import { ExperimentsFlags } from "@/services/amplitude/experiment";

const OriginalButton = ({ onClick }: { onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-[#25D366] text-white transition-colors duration-300 hover:bg-[#1a9f4b]"
    aria-label="Compartilhar no WhatsApp"
  >
    <Icon size="large" use="brand-whatsapp" color="on-color-high" />
  </button>
);

export const WhatsAppFloatingButton = () => {
  const { store, enabledWhatsAppSharing } = useStore();
  const showCartExperiment = useExperiment(ExperimentsFlags.ShowCart);

  const shareToWhatsApp = () => {
    if (enabledWhatsAppSharing) {
      storeAnalitica.events.share.whatsappFloating();

      share.whatsapp(
        store.vitrine.whatsAppNumber,
        MessageBuilder.buildCatalogGreeting(store.name, showCartExperiment)
      );
    }
  };

  if (!enabledWhatsAppSharing) {
    return null;
  }

  return (
    <div className="fixed right-3 bottom-3 z-50 md:right-5 md:bottom-5 xl:right-10 xl:bottom-8">
      <OriginalButton onClick={shareToWhatsApp} />
    </div>
  );
};
